import { create } from 'zustand';

/**
 * Lightweight page → assistant context. The calendar registers the cabinet it's currently showing
 * so a booking command ("book X here / next week") targets that location instead of the default.
 */
interface AssistantContextState {
  cabinetId: string | null;
  setCabinet: (id: string | null) => void;
}

export const useAssistantContext = create<AssistantContextState>((set) => ({
  cabinetId: null,
  setCabinet: (cabinetId) => set({ cabinetId }),
}));
